var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"modal fade",class:{ show: _vm.showModal },staticStyle:{"background-color":"rgba(0, 0, 0, 0.5)"}},[_c('div',{staticClass:"modal-dialog modal-dialog-centered"},[_c('div',{staticClass:"modal-content general"},[_vm._t("default")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }